import { render, staticRenderFns } from "./help-better.vue?vue&type=template&id=d3d64294&scoped=true"
import script from "./help-better.vue?vue&type=script&lang=js"
export * from "./help-better.vue?vue&type=script&lang=js"
import style0 from "./help-better.vue?vue&type=style&index=0&id=d3d64294&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3d64294",
  null
  
)

export default component.exports